import store from "../../../store/store";
import constants from "../../../utils/constants";
import axios from "../../axios";
// Token Refresh
let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(access_token) {
	subscribers = subscribers.filter(callback => callback(access_token));
}

function addSubscriber(callback) {
	subscribers.push(callback);
}

export default {
	getListPonds(payload) {
		return axios.post(constants.API.PONDS.LIST, payload || null);
	},
	createPond(payload) {
		return axios.post(`${constants.API.PONDS.CREATE}`, payload);
	},
	updatePond(id, payload) {
		return axios.put(`${constants.API.PONDS.UPDATE}${id}`, payload);
	},
	updateDaily(id, payload) {
		return axios.put(`${constants.API.PONDS.UPDATE_DAILY}${id}`, payload);
	},
	assignPond(payload) {
		return axios.post(constants.API.USERS.ASSIGN, payload);
	},
	deletePond(id) {
		return axios.delete(`${constants.API.PONDS.DELETE}${id}`);
	},
	getPond(id, payload = null) {
		return axios.get(`${constants.API.PONDS.GET}${id}`, payload);
	},
	getYield(payload = null) {
		return axios.get(`${constants.API.STATISTIC.YIELD}${payload}`, payload);
	}
};
